import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { findRouteData } from 'gain-web/lib/router/find-route-data';
import { ApiClient } from 'gain-web/shared-services/api-client.generated.service';

@Injectable({
  providedIn: 'root',
})
export class DataExchangeContextService {
  private cache = new Map<string, ApiClient.DataExchangeContextDto>();

  constructor(
    private _dataExchangeContextSerivce: ApiClient.DataExchangeContextService,
  ) {}

  async get(portalId: string) {
    if (this.cache.has(portalId)) {
      return this.cache.get(portalId)!;
    }

    const result = await this._dataExchangeContextSerivce
      .getDataExchangeContextByPortalId(portalId)
      .toPromise();
    const dataExchangeContext = result.dataExchangeContext;

    this.cache.set(portalId, dataExchangeContext);

    return dataExchangeContext;
  }
}

export function getDataExchangeContext(route: ActivatedRouteSnapshot) {
  const dataExchangeContext = findRouteData<ApiClient.DataExchangeContextDto>(
    route,
    'dataExchangeContext',
  );

  if (!dataExchangeContext) {
    throw new Error('Could not find data exchange context in route');
  }

  return dataExchangeContext;
}
